/* oxlint-disable */
import React from 'react';

import { IoMdTrophy } from 'react-icons/io';

import Podium from '@/features/svgDesing/Podium';

import { useAuthStore } from '@/stores/userStore';
import { getCurrencySymbol } from '@/utils/currency';

import { ScrollArea } from '@/components/ui/scroll-area';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export const TopPrize = ({
  topPlayers,
  topPrizes,
  otherPrizes,
  mergedArray,
}: {
  topPlayers: any;
  topPrizes: any;
  otherPrizes: any;
  mergedArray: any;
}) => {
  const { account } = useAuthStore();
  
  return (
    <div>
      {' '}
      <div className="flex items-center gap-4">
        <IoMdTrophy className="text-sivarbet-primary text-3xl" />
        <h2 className="text-3xl font-bold max-md:text-xl text-left">
          Premios del Torneo
        </h2>
      </div>
      <section className="flex flex-col md:flex-row justify-around items-center">
        <div className="flex justify-center items-end gap-8">
          <Podium
            // First Place
            FirstPrizeComponent={(
              <>
                <p className="text-lg max-md:text-base text-center pb-1">
                  {topPlayers[0]?.nickname || ''}
                </p>
                <p className="text-sm max-md:text-base text-center pb-2">
                  Puntaje:
                  {' '}
                  {topPlayers[0]?.rating || ''}
                </p>
                <p className="text-3xl max-md:text-xl font-bold text-center pb-2">
                  {topPrizes[0]?.prize_sum}
                  {' '}
                  {getCurrencySymbol(account?.currency ?? 'USD')}
                </p>
              </>
            )}
            // Second Place
            SecondPrizeComponent={(
              <>
                <p className="text-lg max-md:text-base text-center pb-1">
                  {topPlayers[1]?.nickname || ''}
                </p>
                <p className="text-sm max-md:text-base text-center pb-2">
                  Puntaje:
                  {' '}
                  {topPlayers[1]?.rating || ''}
                </p>
                <p className="text-3xl max-md:text-xl font-bold text-center pb-2">
                  {topPrizes[1]?.prize_sum}
                  {' '}
                  {getCurrencySymbol(account?.currency ?? 'USD')}
                </p>
              </>
            )}
            // Third Place
            ThirdPrizeComponent={(
              <>
                <p className="text-lg max-md:text-base text-center pb-1">
                  {topPlayers[2]?.nickname || ''}
                </p>
                <p className="text-sm max-md:text-base text-center pb-2">
                  Puntaje:
                  {' '}
                  {topPlayers[2]?.rating || ''}
                </p>
                <p className="text-3xl max-md:text-xl font-bold text-center pb-2">
                  {topPrizes[2]?.prize_sum}
                  {' '}
                  {getCurrencySymbol(account?.currency ?? 'USD')}
                </p>
              </>
            )}
          />
        </div>

        {/* Other Prizes Cards */}
        <div className="flex flex-col items-center gap-4 w-2/4 max-md:w-full ml-4 max-md:ml-0">
          <div className="relative h-[600px] w-full rounded-lg">
            <Table className="rounded-t-lg">
              <TableHeader className="sticky top-0 z-10">
                <TableRow className="border-none bg-linear-to-br from-[#000000a3] to-[#29ABE2]/20 hover:bg-transparent transition-none">
                  <TableHead className="font-semibold w-1/4 bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                    Posición
                  </TableHead>
                  {mergedArray.length > 0 && (
                    <TableHead className="font-semibold w-1/4 bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                      Jugador
                    </TableHead>
                  )}
                  {mergedArray.length > 0 && (
                    <TableHead className="font-semibold w-1/4 bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                      Puntaje
                    </TableHead>
                  )}
                  <TableHead className="font-semibold w-1/4 bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                    Premio
                  </TableHead>
                </TableRow>
              </TableHeader>
            </Table>
            <ScrollArea className="bg-linear-to-br from-[#000000a3] to-[#29ABE2]/20 h-[calc(612px-2.5rem)] w-full border-s border-e rounded-b-lg border-sivarbet-border">
              <Table>
                <TableBody className="bg-transparent">
                  {mergedArray.length > 0
                    ? mergedArray.map((prize: any, index: number) => {
                      return (
                        <TableRow
                          key={index}
                          className="border-none hover:bg-transparent transition-none"
                        >
                          <TableCell className="font-bold w-1/4 bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                            {index + 4}
                            º
                          </TableCell>
                          <TableCell className="w-1/4">
                            {prize.nickname}
                          </TableCell>
                          <TableCell className="w-1/4">
                            {prize.rating}
                          </TableCell>
                          <TableCell className="w-1/4">
                            {prize.prize}
                            {' '}
                            {getCurrencySymbol(account?.currency ?? 'USD')}
                          </TableCell>
                        </TableRow>
                      );
                    })
                    : otherPrizes.length > 0
                      && otherPrizes.map((prize: any, index: number) => {
                        return (
                          <TableRow
                            key={index}
                            className="border-none hover:bg-transparent transition-none"
                          >
                            <TableCell className="font-bold w-1/4 bg-linear-to-r from-powerbet-accent to-[#ff1a9b] bg-clip-text text-transparent">
                              {index + 4}
                              º
                            </TableCell>
                            <TableCell className="w-1/4">
                              {prize.prize_sum}
                              {' '}
                              HNL
                            </TableCell>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            </ScrollArea>
          </div>
        </div>
      </section>
    </div>
  );
};
